import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const TagsBlock = styled.div`
  margin-top: 0.5rem;
  .tag {
    display: inline-block;
    color: hotpink;
    text-decoration: none;
    margin-right: 0.5rem;
    &:hover {
      color: pink;
    }
  }
`;

const Tags = ({ tags }) => {
  return (
    <div className="Tags">
      <TagsBlock>
        {tags.map(tag => (
          <Link className='tag' to={`/?tag=${tag}`} key={tag}>
            #{tag}
          </Link>
        ))}
      </TagsBlock>
    </div>
  );
};

export default Tags;